import { EMediaType } from '../../components/Carousel/interfaces';
import { IState } from '../../store';
import { getPhotos } from '../../utils/gallery_helpers';

export function getCarouselImages(state: IState) {
  return getPhotos(state).map(({ fullUrl = '', galleryThumbnailUrl = '', thumbnailUrl = '' }, index) => ({
    fullUrl,
    galleryThumbnailUrl,
    isPrimaryImage: !index,
    mediaType: EMediaType.Image,
    thumbnailUrl,
  }));
}
